angular.module('wbDashboard')
.controller('MilestoneModOtherController', ['$scope',
function ($scope) {
    //simple pages: ['name']

    angular.copy([
        'portfolio-type', 'cash-amount', 'portfolios',
        'allocation-start',
        // 'auto-deposit'
    ], $scope.pages);

    if (!['simple', 'auto-deposit', 'portfolio-type', 'portfolio-simple-type', 'allocation-start', 'confirm'].includes($scope.$stateParams.page)) {
        $scope.goToPage($scope.pages[0]);
    }

    $scope.mod.extra.getNextPage = function() {
        var page = null;
        var pageIndex = $scope.pages.indexOf($scope.$stateParams.page);

        //noinspection FallThroughInSwitchStatementJS
        switch ($scope.$stateParams.page) {
            default:
                break;
        }

        return page;
    };

}]);
